export const getEnvLabel = () => {
  switch (import.meta.env.TOURPWA_ENVIRONMENT) {
    case 'local':
      return 'local';
    case 'staging':
      return 'dev';
    case 'uat':
      return 'uat';
    default:
      return null;
  }
};
